/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessResponse_ManagerHomeSummary_ } from '../models/SuccessResponse_ManagerHomeSummary_';
import type { SuccessResponse_StoreMonthCompareTrend_ } from '../models/SuccessResponse_StoreMonthCompareTrend_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ManagerHomeService {
    /**
     * Get Manager Home Endpoint
     * GET /api/v1/stores/{store_id}/manager-home — 店长首页汇总.
     * @returns SuccessResponse_ManagerHomeSummary_ Successful Response
     * @throws ApiError
     */
    public static getManagerHomeEndpointApiV1StoresStoreIdManagerHomeGet({
        storeId,
    }: {
        storeId: number,
    }): CancelablePromise<SuccessResponse_ManagerHomeSummary_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/manager-home',
            path: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Month Compare Endpoint
     * GET /api/v1/stores/{store_id}/month-compare — 单店滚动窗口营收对比 (折线图).
     *
     * 近 window 天(实线) vs 上一个 window 天(虚线); window=7 同星期几对齐, 语义与
     * owner-home/month-compare 一致 (店长灰度反馈 2026-07-07 加 30 天档)。
     * actor_can_see_store 应用层校验 (跨店/非名下→403); super_admin god-mode 由 require_role 放行.
     * @returns SuccessResponse_StoreMonthCompareTrend_ Successful Response
     * @throws ApiError
     */
    public static getStoreMonthCompareEndpointApiV1StoresStoreIdMonthCompareGet({
        storeId,
        window = 7,
    }: {
        storeId: number,
        /**
         * 窗口天数: 7 (近7天vs上一个7天, 同星期几) | 30 (近30天vs上一个30天)
         */
        window?: number,
    }): CancelablePromise<SuccessResponse_StoreMonthCompareTrend_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores/{store_id}/month-compare',
            path: {
                'store_id': storeId,
            },
            query: {
                'window': window,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
